/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sort_FilterInputs */



/**
* | output |
* | --- |
* | "Sort and filter" |
*
* @param {Players_Sort_FilterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sort_filter = /** @type {((inputs?: Players_Sort_FilterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sort_FilterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trier et filtrer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordenar y filtrar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ordenar e filtrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina e filtra")
	return /** @type {LocalizedString} */ ("Sort and filter")
});